import React from "react";
import "./questionModal.css";

const QuestionModal = ({ visible, onClose, onSubmit, feedback, setFeedback }) => {
  if (!visible) return null;

  return (
    <div className="modal_overlay">
      <div className="modal_content">
        <h3>Feedback:</h3>
        <p>What can we do better?</p>
        <textarea
          rows="4"
          cols="50"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Enter your feedback here..."
        />
        <div className="modal_buttons">
          <button onClick={onSubmit}>Submit</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default QuestionModal;
